<template>
    <div class="mt-lg-5 body">
        <div class="pt-2 col-12 col-md-6 col-lg-4">
            <div class="d-flex ml-1 ml-md-5 p-lg-2 pt-5 premiumbtn pointer" @click="navToProfileViews">
                <img src="../assets/Back.svg" class="backbtn mt-1" alt="back"/>
                <p class="fontsize20 proximanova-semibold black ml-2 mt-4">Payment Methods</p>
            </div>
        </div>
        <div v-if="!gotUserDetails">
            <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
        </div>
        <iframe :src="page" id="receiver" v-if="gotUserDetails"
            style="position:relative;z-index:0"
            name="myIframe"
            v-on:load="onLoadIframe" frameborder="0"></iframe>
    </div>
</template>
<script>
import router from '../router.js'
import httpuserprofile from "../js/http-userprofile.js"
import httppayment from "@/js/http-payment.js";
import wndata from '../js/wn_data.json'
import sessionUtils from '@/js/session-util.js'
export default {
    components: {
    },
    watch: {

    },
    data(){
        return {
            page : '',
            clientEmail : '',
            clientId : '',
            currentUserId : null,
            currentUserProfileId : null,
            currentUserDetails : {},
            fullName : '',
            gotUserDetails : false,
            dataSharingObject : {},
            billingCountry : '',
            customerId : null,
            customerDetails : {
                customerId : 0,
                email : null,
                firstName : null,
                lastName : null,
                phoneNumber : null
            },
            subscriptionObj : {
                id : null,
                profileId : null,
                epcustomerId : 0,
                startD : null,
                endD : null,
                planType : 'Customer Registration',
                paymentStatus : null,
                subscriptionD : null,
                transactionD : null,
                amount : null,
                status : '',
                transactionId : null
            },
        }
    },
    
    methods: {
        //this will invoke after click on back button
        navToProfileViews : function(){
            router.push({
                name : 'profileViews'
            })
        },
        // loading an iframe and sending the data from worknotion to easypay
        onLoadIframe() {
            var receiverWindow = document.getElementById("receiver").contentWindow;
            
            this.dataSharingObject.loggedInUser = this.fullName;
            // this.dataSharingObject.clientEmail = 'muthu.p@syntrino.net';
            // this.dataSharingObject.clientId = 'WN_51J4ut0DTZ';
            this.dataSharingObject.clientEmail = this.clientEmail;
            this.dataSharingObject.clientId = this.clientId;
            this.dataSharingObject.customerDetails = this.customerDetails;
            this.dataSharingObject.billingCountry = this.billingCountry;
            
            receiverWindow.postMessage(this.dataSharingObject, this.page);
        },
        //this will invoke after loading the component
        getUserData() {
            httpuserprofile.get('/userprofile/userbyid/'+sessionUtils.getUserId())
            .then(response =>{
                console.log(response)
                this.currentUserDetails = response.data
                this.fullName = this.currentUserDetails.firstName + ' ' + this.currentUserDetails.lastName;
                this.billingCountry = this.currentUserDetails.country.countryName;
                this.customerDetails.email = this.currentUserDetails.email;
                this.customerDetails.firstName = this.currentUserDetails.firstName;
                this.customerDetails.lastName = this.currentUserDetails.lastName;
                this.customerDetails.phoneNumber = this.currentUserDetails.primaryPhoneNumber;
                if(this.customerId === null || this.customerId === 0 || this.customerId === undefined){
                    //this.registerCustomer()
                }else{
                    this.gotUserDetails = true;
                }
            }).catch((e) => {
                console.log(e.response)
                this.gotUserDetails = false;
            })
        },
        // this will invoke if current user dont register with easypay
        registerCustomer(){
            let registrationObj = {
                customerDetails : this.customerDetails,
                address: {
                    addressLine1: "string",
                    addressLine2: "string",
                    addressType: "string",
                    city: "string",
                    country: this.billingCountry,
                    postalCode: "string",
                    state: "string"
                },
            }
            if(this.customerId === null || this.customerId === 0 || this.customerId === undefined){
                httppayment.post('/payment/registerCustomer', registrationObj)
                .then((response) => {
                    console.log("successfully customer registered : ", response)
                    if(response.data.customerDetails) {
                        this.customerId = response.data.customerDetails.customerId;
                        this.customerDetails.customerId = response.data.customerDetails.customerId;
                        this.subscriptionObj.epcustomerId = response.data.customerDetails.customerId;
                        localStorage.setItem('epCustomerId', this.customerId)
                        this.savedCustomerDetails()
                    }
                    this.gotUserDetails = true;
                }).catch((e) => {
                    console.log(e.response)
                })
            }else{
                console.log("already registered with easy pay");
                this.gotUserDetails = true;
            }
            
        },
        // saving ep customer details in subscription 
        savedCustomerDetails(){
            console.log(this.subscriptionObj)
            // httpuserprofile.post('/userprofile/SubscriptionUsers', this.subscriptionObj)
            // .then((response) => {
            //     console.log("saved customerData : ", response.data)
            //     localStorage.setItem('epCustomerId', response.data.epcustomerId)
            // }).catch((e) => {
            //     console.log(e.response)
            // })
            httpuserprofile.post('userprofile/updateUserAssignment?profileId='+this.currentUserProfileId+'&roleName=&epCustomerId='+this.subscriptionObj.epcustomerId)
            .then((response) => {
                console.log(response)
            }).catch((e) => {
                console.log(e.response)
            })
        }
    },
    created(){        
        window.scrollTo(0, 0);
        this.page = wndata.easyPayStoredPayments;
        this.clientEmail = wndata.clientEmail;
        this.clientId = wndata.clientId;
        this.currentUserId = sessionUtils.getUserId();
        this.currentUserProfileId = sessionUtils.getUserProfileId()
        this.subscriptionObj.profileId = this.currentUserProfileId;
        // let customerId = localStorage.getItem('epCustomerId')
        let customerId = localStorage.getItem('profileId')
        if(customerId !== null || customerId !== 0 || customerId !== undefined){
            this.customerId = customerId;
            this.customerDetails.customerId = customerId;
        }
        this.getUserData()
    },
    destroyed() {
    }
}
</script>
<style scoped>
iframe{
    width: 100%;
    height: 100vh;
}
.pageloader {
  width: 6%;
  margin-top: 10%;
  margin-left: 46%;
}
html,
body,
.grid {
    height: 100%;
    width: 100%;
}
</style>
